import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

// A Choices.js multiselect grouped by fleet (native <optgroup>s). Each
// group's first <option value="fleet:ID"> is a "select all in this
// fleet" pseudo-choice — picking it selects every real server option
// under that fleet (data-fleet-id="ID") and removes itself again, since
// it isn't a real server and shouldn't be submitted as one.
export default class extends Controller {
  static targets = ["select"]

  static values = {
    noResultsText: { type: String, default: "No results found" },
    noChoicesText: { type: String, default: "No choices to choose from" },
  }

  connect() {
    // Choices.js wraps the select in new container elements, moving it in
    // the DOM. If data-controller lived on the select itself, that move
    // would re-trigger Stimulus's connect/disconnect lifecycle forever, so
    // the controller lives on this stable wrapper instead (see
    // _server_select.html.erb) and only touches the select via the target.
    this.choices = new Choices(this.selectTarget, {
      removeItemButton: true,
      shouldSort: false,
      searchResultLimit: 50,
      itemSelectText: "",
      removeItemIconText: () => "×",
      noResultsText: this.noResultsTextValue,
      noChoicesText: this.noChoicesTextValue,
    })

    this.onAddItem = this.onAddItem.bind(this)
    this.selectTarget.addEventListener("addItem", this.onAddItem)
  }

  disconnect() {
    this.selectTarget.removeEventListener("addItem", this.onAddItem)
    this.choices?.destroy()
  }

  onAddItem(event) {
    const value = event.detail.value
    if (!value.startsWith("fleet:")) return

    const fleetId = value.slice("fleet:".length)
    const serverValues = Array.from(this.selectTarget.querySelectorAll(`option[data-fleet-id="${fleetId}"]`)).map((option) => option.value)

    this.choices.removeActiveItemsByValue(value)
    if (serverValues.length > 0) this.choices.setChoiceByValue(serverValues)
  }
}
